import React, { useContext } from "react";
import { useRoutes } from "react-router-dom";
import Home from "../pages/home/home";
import Search from "../pages/search/search";
import Dashboard from "../pages/dashboard/dashboard";
import Evaluation from "../pages/evaluation/evaluation";
import Summary from "../pages/evaluation/summary";
import BatchEvaluation from "../pages/batchEvaluation/batchEvaluation";
import Login from "../pages/login/login";
import DimensionsPage from "../pages/dimensions/DimensionsPage";
import { UsuarioAutenticadoContext } from "../context/authenticatedUser";

export default function Router() {
  var initialRoutes = [
    { path: "*", element: <Home /> },
    { path: "/login", element: <Login /> },
    { path: "/", element: <Home /> },
    { path: "/evaluation", element: <Evaluation /> },
    {
      path: "/evaluation/:tipo/:ambito/:actividad/:objetivo",
      element: <Evaluation />,
    },
    {
      path: "/evaluation/:tipo/:ambito/:actividad/:objetivo/:operacion",
      element: <Evaluation />,
    },
    {
      path: "/evaluation/:tipo/:ambito/:actividad/:objetivo/:status/:consulta",
      element: <Evaluation />,
    },
    {
      path: "/summary/:tipo/:ambito/:actividad/:objetivo/:status/:consulta",
      element: <Summary />,
    },
    { path: "/batchevaluation", element: <BatchEvaluation /> },
    { path: "/:param", element: <Home /> },
    { path: "/search", element: <Search /> },
    { path: "/dimensions", element: <DimensionsPage /> },
  ];

  const {usuarioAutenticado} = useContext(UsuarioAutenticadoContext)
  const id = usuarioAutenticado?.permiso_ver_dashboard;
  if (parseInt(id) > 0) {
    initialRoutes.push({ path: "/dashboard", element: <Dashboard /> });
  }

  return useRoutes(initialRoutes);

  /*  const routes = {
    "/": () => <Home />,
    "/newaction": () => <NewAction />,
    "/evaluate": () => <Evaluate />
  };*/
}
